import { humanReadableDiscipline } from '~/utilities';
import { Badge } from '@janeapp/burrito-design-system';

interface DisciplinesProps {
  id: string;
  badges: string[];
  maxToShow?: number;
  className?: string;
  dataTestId?: string;
}

export const BadgeList = ({
  id,
  badges,
  maxToShow,
  className,
  dataTestId,
}: DisciplinesProps) => {
  const listTailLength = maxToShow ? badges.length - maxToShow : 0;

  return (
    <div
      className={`${className} flex flex-row flex-wrap gap-1`}
      data-testid={dataTestId}
    >
      {badges.slice(0, maxToShow).map((content: string, i: number) => (
        <Badge key={`badge-${id}-${i}`} tone="neutral" className="text-sm">
          {humanReadableDiscipline(content)}
        </Badge>
      ))}
      {listTailLength > 0 && <Badge content={`+${listTailLength}`} />}
    </div>
  );
};
